import { z } from 'zod';
import { PaddingSettingSchema } from '../setting/padding-setting';
import { TipTapContentSchema } from '../tiptap-content.schema';
import { BasePinComponentSchema, BasePinComponentSettingsSchema } from './base-pin-component';

const FillInTheBlanksAreaHorizontalAlignmentSchema = z.enum(['left', 'center', 'right']);
export type FillInTheBlanksAreaHorizontalAlignmentKey = z.infer<typeof FillInTheBlanksAreaHorizontalAlignmentSchema>;

export const FillInTheBlanksAreaPinComponentPinThemeSettingsSchema = z.object({
  backgroundColor: z.string().min(1).optional(),
  borderColor: z.string().optional(),
  borderRadius: z.number().optional(),
  fontFamily: z.string().min(1).optional(),
  fontSize: z.string().optional(),
  fontColor: z.string().min(1).optional(),
  fontWeight: z.string().optional(),
  lineHeight: z.number().optional(),
  paragraphSpacing: z.number().optional(),
  transparency: z.number().optional(),
  padding: PaddingSettingSchema.optional(),
});
export type FillInTheBlanksAreaPinComponentPinThemeSettings = z.infer<
  typeof FillInTheBlanksAreaPinComponentPinThemeSettingsSchema
>;

const FillInTheBlanksAreaPinComponentSettingsSchema = BasePinComponentSettingsSchema.extend(
  FillInTheBlanksAreaPinComponentPinThemeSettingsSchema.extend(
    z.object({
      // fill in the blanks related settings
      tipTapContent: TipTapContentSchema, // THis is where the text will be (and the blanks)
      distractors: z.array(z.string()), // Words the theacher can add as extra options
      sortingSeed: z.number(), // value to sort the words in the wordbank, random but determanistic
      // text settings
      horizontalAlignment: FillInTheBlanksAreaHorizontalAlignmentSchema.optional(),
      strike: z.boolean().optional(),
      underline: z.boolean().optional(),
    }).shape
  ).shape
);
export type FillInTheBlanksAreaPinComponentSettings = z.infer<typeof FillInTheBlanksAreaPinComponentSettingsSchema>;

export const FillInTheBlanksAreaPinComponentTypeSchema = z.literal('FILL_IN_THE_BLANKS_AREA');

export const FillInTheBlanksAreaPinComponentSchema = BasePinComponentSchema.extend(
  z.object({
    type: FillInTheBlanksAreaPinComponentTypeSchema,
    settings: FillInTheBlanksAreaPinComponentSettingsSchema,
  }).shape
);
